export const de = {
    translation: {
        common: {
            account: 'Konto',
            loading: 'Wird geladen...',
            cancel: 'Abbrechen',
            close: 'Schließen',
            verifyCode: 'Code bestätigen',
            disable: 'Deaktivieren',
            setup: 'Einrichten',
            retry: 'Wiederholen',
        },
        shell: {
            pageTitle: '{{tenantName}} Konto',
            security: 'Sicherheit',
            securityDescription:
                'Verwalten Sie Ihr Passwort und schützen Sie Ihr Konto mit Zwei-Faktor-Authentifizierung.',
            securityNav: 'Sicherheit',
            signOut: 'Abmelden',
            tenantSpace: 'Mandantenkonto',
        },
        states: {
            missingTenantTitle: 'Mandantenpfad fehlt',
            missingTenantDescription: 'Diese Konto-App erwartet eine URL im Format /t/:tenantSlug.',
            disabledTitle: 'Kontoverwaltung ist deaktiviert',
            disabledDescription: 'Dieser Mandant hat die Self-Service-Kontoverwaltung noch nicht aktiviert.',
            redirectingDescription: 'Weiterleitung zur Anmeldung...',
            redirectingBody: 'Sie benötigen eine aktive Sitzung, um dieses Konto zu verwalten.',
            externalCredentialsTitle: 'Von Ihrem Anmeldeanbieter verwaltet',
            externalCredentialsDescription:
                'Ihre Anmeldeeinstellungen werden von dem Anbieter verwaltet, den Sie für den Zugriff auf dieses Konto verwenden.',
            externalCredentialsBody:
                'Ihr Passwort und Ihre Anmelde-Bestätigungsmethoden werden von dem Anbieter gesteuert, den Sie für den Zugriff auf dieses Konto verwenden.',
            notFoundTitle: 'Seite nicht gefunden',
            notFoundDescription: 'Die gesuchte Seite existiert nicht.',
            fatalErrorTitle: 'Dienst nicht verfügbar',
        },
        password: {
            description: 'Verwalten Sie das Passwort, das Sie für die Anmeldung bei diesem Konto verwenden.',
            unavailable:
                'Diese Identität verwendet in diesem Mandanten derzeit kein lokales Passwort für die Anmeldung.',
            itemTitle: 'Passwort',
            dialogTitle: 'Passwort ändern',
            dialogDescription: 'Wählen Sie ein neues Passwort für zukünftige Anmeldungen.',
            changeAction: 'Passwort ändern',
            requirementsTitle: 'Anforderungen',
            newPassword: 'Neues Passwort',
            confirmPassword: 'Neues Passwort bestätigen',
            confirmPasswordMismatch: 'Die Passwörter stimmen noch nicht überein.',
            update: 'Passwort aktualisieren',
            requirements: {
                length: 'Mindestens {{minLength}} Zeichen',
                lower: 'Ein Kleinbuchstabe',
                upper: 'Ein Großbuchstabe',
                digit: 'Eine Ziffer',
                special: 'Ein Sonderzeichen (z. B. - + _ ! @ # $ % ^ & * . , ? < > =)',
                noRepeat: 'Nicht mehr als 2 identische Zeichen hintereinander',
            },
        },
        mfa: {
            title: 'Zwei-Faktor-Authentifizierung (2FA)',
            description: 'Fügen Sie Ihrem Konto eine zusätzliche Sicherheitsebene hinzu.',
            unavailable: 'Zwei-Faktor-Authentifizierung ist für diesen Mandanten nicht verfügbar.',
            on: 'An',
            off: 'Aus',
            totpTitle: 'Authenticator-App',
            totpDescription:
                'Erzeugen Sie Verifizierungscodes mit einer App wie Google Authenticator, Authy oder 1Password.',
            emailTitle: 'E-Mail-Codes',
            emailDescription: 'Erhalten Sie Verifizierungscodes per E-Mail bei der Anmeldung.',
            removeTotp: 'Deaktivieren',
            setupTotp: 'Einrichten',
            enableEmail: 'Einrichten',
            resendEmail: 'Neuen Code senden',
            disableEmail: 'Deaktivieren',
            emailPendingTitle: 'E-Mail-Verifizierung abschließen',
            emailPendingDescription:
                'Geben Sie den Verifizierungscode ein, den wir an Ihre primäre E-Mail-Adresse gesendet haben.',
            emailCodeLabel: 'Verifizierungscode',
            totpModalTitle: 'Authenticator einrichten',
            totpModalDescription:
                'Scannen Sie diesen QR-Code mit Ihrer Authenticator-App. Falls das nicht möglich ist, können Sie den Einrichtungsschlüssel manuell eingeben.',
            totpCopy: 'Kopieren',
            totpCopied: 'Kopiert',
            totpCodeLabel: '6-stelligen Code eingeben',
            totpVerify: 'Code bestätigen',
        },
        messages: {
            loadError: 'Die Kontoansicht konnte nicht geladen werden.',
            signOutSuccess: 'Sie wurden aus der Konto-App abgemeldet.',
            signOutError: 'Abmelden ist derzeit nicht möglich.',
            passwordMismatch: 'Die Bestätigung des neuen Passworts stimmt nicht überein.',
            passwordUpdated: 'Ihr Passwort wurde aktualisiert.',
            passwordUpdateError: 'Das Passwort konnte nicht geändert werden.',
            emailVerified: 'E-Mail-MFA wurde aktiviert.',
            emailDisabled: 'E-Mail-MFA wurde deaktiviert.',
            emailUpdateError: 'E-Mail-MFA konnte nicht aktualisiert werden.',
            emailVerifyError: 'Der E-Mail-Code konnte nicht bestätigt werden.',
            totpEnabled: 'Authenticator-App-MFA wurde aktiviert.',
            totpRemoved: 'Authenticator-App-MFA wurde entfernt.',
            totpStartError: 'Die Authenticator-Einrichtung konnte nicht gestartet werden.',
            totpVerifyError: 'Der Authenticator-Code konnte nicht bestätigt werden.',
            totpRemoveError: 'Der Authenticator-Faktor konnte nicht entfernt werden.',
        },
    },
}
